export default [{"tag":"path","att":{"d":"M4 5v10h2V7h12v8h2V5H4zM2 19h20v-2H2v2z"}}]